import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_USER_PROFILE_URL,
  UPDATE_USER_PROFILE_URL,
  CHANGE_USER_PASSWORD_URL,
  UPDATE_TIME_SPENT_URL,
  GET_PENDING_URL,
  GET_BADGES_URL,
  GET_COINS_URL,
  GET_USER_AI_EVAL_DETAILS_URL,
  GET_USER_AI_EVAL_TEST_URL,
  GET_USER_AI_EVAL_QUIZ_URL,
  GET_USER_AI_EVAL_CONTENT_URL,
  GET_USER_AI_EVAL_TUTOR_URL,
  REGENERATE_USER_AI_EVAL_TEST_URL,
} from "../apiurls/apiurls";


export const getUserAiEvalDetails = async (targetType, targetId) => {
  try {
    const response = await axiosInstance.get(GET_USER_AI_EVAL_DETAILS_URL, {
      params: { target_type: targetType, target_id: targetId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user AI evaluation details:", error);
    throw error;
  }
};

export const getUserAiEvalTest = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_USER_AI_EVAL_TEST_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user AI test evaluations:", error);
    throw error;
  }
};

export const regenerateUserAiEvalTest = async (params = {}) => {
  try {
    const response = await axiosInstance.post(REGENERATE_USER_AI_EVAL_TEST_URL, {}, { params });
    return response.data;
  } catch (error) {
    console.error("Error regenerating user AI test evaluation:", error);
    throw error;
  }
};



export const getUserAiEvalQuiz = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_USER_AI_EVAL_QUIZ_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user AI quiz evaluations:", error);
    throw error;
  }
};


export const getUserAiEvalContent = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_USER_AI_EVAL_CONTENT_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user AI content evaluations:", error);
    throw error;
  }
};

export const getUserAiEvalTutor = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_USER_AI_EVAL_TUTOR_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user AI tutor evaluations:", error);
    throw error;
  }
};

export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get(GET_USER_PROFILE_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const getUserBadges = async () => {
  try {
    const response = await axiosInstance.get(GET_BADGES_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching user badges:", error);
    throw error;
  }
};

export const getUserCoins = async () => {
  try {
    const response = await axiosInstance.get(GET_COINS_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching user coins:", error);
    throw error;
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const response = await axiosInstance.put(
      UPDATE_USER_PROFILE_URL,
      profileData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error);
    throw error;
  }
};

export const updateUserTimeSpent = async (payload) => {
  try {
    const response = await axiosInstance.post(UPDATE_TIME_SPENT_URL, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating user time spent:", error);
    throw error;
  }
};

export const getPendingData = async () => {
  try {
    const response = await axiosInstance.get(GET_PENDING_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching pending data:", error);
    throw error;
  }
};

export const changeUserPassword = async (passwordData) => {
  try {
    const response = await axiosInstance.post(
      CHANGE_USER_PASSWORD_URL,
      passwordData,
    );
    return response.data;
  } catch (error) {
    console.error("Error changing user password:", error);
    throw error;
  }
};
